import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ColorPicker } from "../components/editor/ColorPicker";
import { SubmitPreviewImage } from "../components/editor/SubmitPreviewImage";
import { Btn } from "../components/UI/Btn";
import { T } from "../i18n/LocaleType";
import { useBackendContext, useBackendContextMessages } from "../services/backend/backendContextProvider";
import { useStrokeContext } from "../services/editor/editorContext";
import { useRouterContext } from "../services/router/routerContext";

export const ColorPage: React.FC = () => {

    const { clear, color, setColor } = useStrokeContext();
    const { showEditor, showStage } = useRouterContext();
    const { submit } = useBackendContext();

    const { t } = useTranslation();

    const { addMessage } = useBackendContextMessages();

    const backHandler = useCallback(() => {

        clear();
        setColor(undefined);
        showEditor();

    }, [clear, setColor, showEditor]);

    const { processedBase64, processedNormalized } = useStrokeContext();

    const maySubmit = !!(processedBase64 && processedNormalized && color);

    const nextHandler = useCallback(async () => {

        if (maySubmit && color && processedBase64 && processedNormalized) {

            submit(
                JSON.stringify(processedNormalized),
                processedBase64,
                color,
                "blue",
                "branka"
            );

            addMessage(t(T.sending_image_plese_wait), true, 2000);

            // showStage();

        }

    }, [submit, maySubmit, processedBase64, processedNormalized, color, showStage, addMessage]);


    return <>

        <div style={{
            gridArea: "main",
            width: "100%",
            display: "flex",
            justifyContent: "center",

        }}>
            <div>
                <SubmitPreviewImage />
            </div>
        </div>

        <div style={{ gridArea: "sub" }}>

            <ColorPicker />

        </div>

        <Btn
            area="left"
            icon="left"
            square
            inverse
            onClick={backHandler}
        />

        {color && <Btn
            area="right"
            icon="right"
            onClick={nextHandler}
        >{t(T.send)}</Btn>}

    </>;


}